'use client';

const listeners = new Set<() => void>();
export function onActivationActivity(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
/** A refresh hint only. The server independently checks persisted evidence before paying. */
export function notifyActivationActivity() {
  for (const listener of listeners) listener();
}

/** Own the activity subscription and its pending refresh together. */
export function subscribeActivationRefresh(refresh: () => void) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (document.visibilityState === 'visible') refresh();
    }, 2500);
  };
  const unsubscribe = onActivationActivity(schedule);
  window.addEventListener('focus', schedule);
  return () => {
    clearTimeout(timer);
    unsubscribe();
    window.removeEventListener('focus', schedule);
  };
}
